import React from "react";

import { Section } from "components/Section";
import Text from "components/Text";
import Fields from "components/guides/Fields";

import styles from "./EventDetails.scss";

// TODO: move this to projects/
const EventDetails = () => (
  <div className={styles.details}>
    <Section heading={<Text t="guides.summary.location" />}>
      <Fields
        hideLabel
        hideIfUnanswered
        fieldIdents={[
          "field:event_routes",
          "field:event_locations",
          "field:event_geoms",
          "field:event_addresses",
        ]}
        behaviorType="disabled"
      />
    </Section>

    <Section heading={<Text t="guides.summary.dates_and_times" />}>
      <Fields
        hideLabel
        hideIfUnanswered
        fieldIdents={["field:event_times"]}
        behaviorType="disabled"
      />
    </Section>
  </div>
);

export default EventDetails;
